__turbopack_context__.v({
  "item": "TableBlock-module-scss-module__Vbfd3W__item",
  "list": "TableBlock-module-scss-module__Vbfd3W__list",
  "section": "TableBlock-module-scss-module__Vbfd3W__section",
  "title": "TableBlock-module-scss-module__Vbfd3W__title",
});
